<div class="ion-header ion-hide-lg-up s">
  <header-main></header-main>
</div>

<main class="ion-content" fullscreen>
  <header class="ion-hide-lg-down gr">
    <header-desktop></header-desktop>
    <h1>
      Categories
    </h1>
  </header>

  <div class="container">
    <div class="sub-heading">
      <p>Check out our industry classifications for our gig economy, jobs site, volunteer & business or freelance adverts.</p>
    </div>
  </div>

  <div class="container">
    <div class="grid ion-no-padding">
      <ng-container *ngFor="let grouping of groupings; let i = index;">
        <div class="row categories-heading" [ngClass]="{'active': selectedCategory === grouping}">
          <div class="col col-xs-12 ion-no-padding">
            <h3 (click)="onSelected(grouping)">
              {{grouping}}
              <svg class="ion-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29.19 29.19"><defs><style>.arrow-right{fill:inherit;stroke:none;}</style></defs><title>arrow-right</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="arrow-right" d="M14.6,29.19a14.6,14.6,0,1,1,14.59-14.6A14.62,14.62,0,0,1,14.6,29.19ZM14.6,1a13.6,13.6,0,0,0,0,27.19h0A13.6,13.6,0,0,0,14.6,1Z"/><path class="arrow-right" d="M13.07,19.73a1,1,0,0,1-.76-.35A1,1,0,0,1,12.42,18l4-3.38-4-3.37a1,1,0,0,1-.11-1.41,1,1,0,0,1,1.4-.12l4.88,4.14a1,1,0,0,1,0,1.53L13.71,19.5A1,1,0,0,1,13.07,19.73Z"/></g></g></svg>
            </h3>
          </div>
        </div>
        <div class="row categories-content" [ngClass]="{'active': selectedCategory === grouping}">
          <div *ngFor="let category of classifications[grouping]" class="col col-xs-12 col-sm-6 col-lg-4 col-xl-3 ion-no-padding">
            <p>{{category}}</p>
          </div>
        </div>
      </ng-container>
    </div>
    <p>If you are a contractor, gig worker, or freelancer working in the global gig economy and we missed a work classification specific to your skills, please use the <a href="/contact">contact us</a> page to advise.</p>
    <p>If you are a small or medium business, looking to find and hire freelancers, contractors, gig workers, permanent, contract, temporary, temping, part time or casual workers we can accommodate any new classification requests relevant to your service you provide.</p>
    <p>If you are a job seeker or job hunter (or backpacker travelling the world on a WHV working holiday visa) searching for new jobs in various countries on our job site platform, you may <a href="/contact">contact us</a> if any of your skills are not present.</p>
    <p>We wish you all the best of luck in finding work where ever you are in the world.</p>
    <p class="categories-note">
      <small>* categories subject to change</small><br />
    </p>
  </div>

  <div class="sign-up-banner">
    <div class="sub-heading">
      <h6>Sign up and begin completing your gigs with us - <a href="/sign-up"><button class="button button-white button-round">Click Here</button></a></h6>
    </div>
  </div>
  
  <footer class="ion-hide-lg-down">
    <footer-desktop></footer-desktop>
  </footer>
</main>

<footer class="ion-footer ion-hide-lg-up">
  <footer-main></footer-main>
</footer>
